import * as theme from "../theme";

import { useContext, useState } from "react";

import Radio from "@mui/material/Radio";
import { parsePhoneNumber } from "react-phone-number-input";
import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import InputContainer from "../components/inputs/InputContainer";
import ValidatedPhoneInput from "../components/inputs/ValidatedPhoneInput";
import Context from "../contexts/data";

const PhoneNumber = () => {
  const { errorMessage, handleUpdateFormValue, generateTwilioCode, navigate } = useContext(Context);

  const [phoneValue, setPhoneValue] = useState();
  const [verificationMethod, setVerificationMethod] = useState("sms");

  const handleToggleType = (method) => {
    if (verificationMethod !== method) {
      setVerificationMethod(method);
    }
  };

  const handleNextStep = async () => {
    if (!phoneValue || phoneValue.length === 0) {
      handleUpdateFormValue("errorMessage", "Please enter your phone number.");
      return;
    }

    const returnedPhoneNumber = parsePhoneNumber(phoneValue);
    if (returnedPhoneNumber.country !== "US") {
      handleUpdateFormValue(
        "errorMessage",
        "Please enter a valid US phone number."
      );
      return;
    }

    const cleanPhoneNumber = phoneValue.replace("+1", "");
    generateTwilioCode(cleanPhoneNumber, verificationMethod);
    handleUpdateFormValue("phoneNumber", cleanPhoneNumber);

    navigate("verification", "Phone");
  };

  return (
    <Wrapper>
      <HeaderText
        bigger_text={
          "What is Your Phone Number?"
        }
        smaller_text={
          window.innerWidth > 500 &&
          "Complete this last step to receive your offers."
        }
      />
      <InputContainer inputClass={"genericContainer"}>
        <ValidatedPhoneInput
          name="phone number"
          errorMessage={errorMessage}
          value={phoneValue}
          onChange={setPhoneValue}
          placeholder={"(XXX) XXX-XXXX"}
          labelName={"Phone Number"}
        />
      </InputContainer>
      <GetSmSContainer>
        <RadioBoxContainer>
          <StyledCheckBox
            onClick={() => handleToggleType("sms")}
            checked={verificationMethod === "sms"}
          />
          <RadioBoxTextContainer>
            <RadioBoxText>Send code via text message</RadioBoxText>
          </RadioBoxTextContainer>
        </RadioBoxContainer>
        <RadioBoxContainer>
          <StyledCheckBox
            onClick={() => handleToggleType("call")}
            checked={verificationMethod === "call"}
          />
          <RadioBoxTextContainer>
            <RadioBoxText>Send code via phone call</RadioBoxText>
          </RadioBoxTextContainer>
        </RadioBoxContainer>
      </GetSmSContainer>

      <ErrorMessage />
      <Button onClick={handleNextStep} hideBBB={true} />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)``;

const GetSmSContainer = styled.div`
  width: 26rem;
  margin: 1rem 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: ${theme.mobile}) {
    width: 80%;
  }
`;

const RadioBoxContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${theme.mobile}) {
  }
`;

const RadioBoxTextContainer = styled.div``;

const RadioBoxText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0.5rem 0.5rem;

  @media (max-width: ${theme.mobile}) {
    margin: 0 0.5rem;
  }
`;

const StyledCheckBox = styled(Radio)`
  margin: 0 0.5rem 0 1rem !important;
  padding: 0 !important;
  color: ${theme.primary_light} !important;
`;


export default PhoneNumber;
